<template>
	<div class="pin-modal" v-if="isOpen"  :style="{left:x+'px',top:y+'px'}">
		<div class="holder" @mousedown="moveStart">{{label}}<btn icon="times" s='xs' t='d' pull="right" @press="isOpen=false"/></div>
		<div>
			<slot/>
		</div>
	</div>
</template>

<script>
export default {

  name: 'pin-modal',
  props:{
  	label:String
  },
  data () {
    return {
		isOpen:false,
		x:0,
		y:0,
		startX:0,
		startY:0,
		startPosX:0,
		startPosY:0

    }
  },
  methods:{
	onOpen(e){
		console.log('OPEN PIN MODAL',e)
		this.isOpen=!this.isOpen;
		if(this.isOpen){
			this.x = e.pageX;
			this.y = e.pageY;
		}
	},
	onMove(e){
		let {startX, startY} = this;
		let {pageX, pageY} = e;
		let d = {x:pageX-startX,y:pageY-startY};
		console.log(this.startPosX, this.startPosY)
		this.x = this.startPosX + d.x;
		this.y = this.startPosY + d.y;
		console.log(d);
	},
	moveStart(e){
		console.log(e)
		document.addEventListener('mousemove', this.onMove);
		document.addEventListener('mouseup', this.moveStop);
		this.startX = e.pageX;
		this.startY = e.pageY;
		this.startPosX = this.x;
		this.startPosY = this.y;
	},
	moveStop(e){
		document.removeEventListener('mousemove', this.onMove);
		document.removeEventListener('mouseup', this.moveStop);
	}
  }
}
</script>

<style lang="css" scoped>
	.pin-modal{
		position:fixed;
		background: white;
		border:1px solid lightgrey;
		border-radius: 4px;
	}

	.holder{
		background: white;
		cursor:move;
		padding:4px 4px;
		font-size: 14px;
	}
</style>